query CompanyPeriodFrequencies {
  companyPeriodFrequencies {
    nodes {
      id
      frequencyName
    }
  }
}
